import React, {useState, useEffect} from 'react'
import Navbar from '../components/Navbar'
import '../assets/css/dashboard.css'
import { Link, useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faSignInAlt, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import bcard from '../assets/images/bcard.png'
import { Greet } from '../components/DashboardComponent'
import { Transactions } from '../components/TransactionComponent'
import DepositToAWallet from '../components/modals/DepositToAWallet'
import WithdrawFromAWallet from '../components/modals/WithdrawFromAWallet'
import BalanceStatement from '../components/modals/BalanceStatement'
import { getUser } from '../utils/profile';

const Wallet = () => {
    const history = useHistory()
    if (!sessionStorage.getItem('idToken')) {
        history.push('/signin')
    }

    const [profile, setProfile] = useState(null)
    const [, setIsPending] = useState(false)
    const [, setError] = useState(null)

    const [fromCoin] = useState('Binance')
    const [amount, setAmount] = useState(1)
    const [toCoin, setToCoin] = useState('Coinbase')
    const convertedAmt = parseFloat(amount)

    useEffect(() => {
        document.title = 'Pouch | Wallet'
        const fetchUser = async () => {
            setIsPending(true)
            let user = await getUser(sessionStorage.getItem('localId'))
            console.log(user)
            if (!user) {
              setError('Could not fetch user data')
            } else {
              if(user.code === 400) {
                setError(user.message || 'Could not fetch user data')
              } else {
                setProfile(user)
              }
            }
        }
        fetchUser()
        setIsPending(false)
        console.log(profile)
        // eslint-disable-next-line
    }, [])

    return (
        <>
            <Navbar />
            <div className="container">
                {/* Wallet hero */}
                <div className="row mx-1 my-3">
                    <Greet />
                </div>
                <div className="row d-flex justify-content-around text-white">
                    <div className="col-md mx-4 p-3 dash-card bg-1 h6 display-6">
                        <img src={bcard} alt="bcard" className="rounded shadow-lg float-right" style={{minWidth: '20%', maxWidth: '30%'}} />
                        <h2><span style={{textDecoration: 'double line-through'}}>N</span>100,000</h2>
                        <h6 className="text-light">$200.01</h6>
                        <Link to="#" type="button" data-toggle="modal" data-target="#modalBalanceStatement" className="small badge badge-primary">View Statement <FontAwesomeIcon icon={faAngleRight} className="ml-2" /></Link>                    
                        <p>
                            <Link to="#" className="btn btn-primary my-2 mr-2" type="button" data-toggle="modal" data-target="#modalDepositToAWallet"><FontAwesomeIcon icon={faSignInAlt} /> Deposit</Link>
                            <Link to="#" className="btn btn-light my-2 mx-1" type="button" data-toggle="modal" data-target="#modalWithdrawFromAWallet"><FontAwesomeIcon icon={faSignOutAlt} /> Withdraw</Link>
                        </p>
                    </div>
                </div>

                <hr className="bg-purple-shade" />

                {/* Wallet and quick transfer */}
                
                <div className="row p-3 my-3">
                    <div className="col-12 col-md m-1 py-2 shadow">
                        <div className="pb-3 m-0">
                            <h6>Transactions
                                <select name="" className="float-right rounded px-2 py-1 btn btn-outline-purple">
                                    <option value="" onChange={() => {}}>Today</option>
                                    <option value="" onChange={() => {}}>This Year</option>
                                    <option value="" onChange={() => {}}>This Week</option>
                                    <option value="" onChange={() => {}}>This Month</option>
                                </select>
                            </h6>
                        </div>
                        <div style={{ maxHeight : '180px', overflow : 'auto'}}>
                            {[1, 2, 3, 4, 5, 6].map(ele => {
                                return (
                                    <Transactions
                                        key={ele}
                                        name="Amazon Store"
                                        rise="-$28.34"
                                        desc="Books"
                                        date="12 Feb 2018"
                                    />
                                )
                            })}
                        </div>
                    </div>
                    <div className="col-12 col-md m-1 py-2 shadow">
                        <h6>Quick Transfer</h6>
                        <form action="">
                            <div className="row">
                                <div className="col-8">
                                    <div className="form-group">
                                        <label htmlFor="">To</label>
                                        <select className="form-control" onChange={e => {setToCoin(e.target.value)}}>
                                            {['Coinbase', 'Lunno', 'Binance'].map((ele, idx) => {
                                                return(
                                                    ele !== fromCoin && <option key={idx} value={ele} >{ele}</option>
                                                    )
                                                }
                                            )}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                                    <div className="form-group">
                                        <label htmlFor="">Withdrawing</label>
                                        <div className="input-group">
                                            <input className="form-control" placeholder="Amount..." defaultValue="1" onChange={(e) => {parseFloat(setAmount(e.target.value))}} />
                                            <div className="input-group-append">
                                                <div className="input-group-text">{fromCoin}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                                    <div className="form-group">
                                        <label htmlFor="">Receiving</label>
                                        <div className="input-group">
                                            <input className="form-control" value={convertedAmt.toString()} onChange={() => {}} />
                                            <div className="input-group-append">
                                                <div className="input-group-text">{toCoin}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button className="btn btn-purple btn-block" onClick={e => {e.preventDefault()}}>
                                <FontAwesomeIcon icon={faSignOutAlt} /><span>Transfer Now</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <DepositToAWallet/>
            <WithdrawFromAWallet />
            <BalanceStatement />
        </>
    )
}

export default Wallet